import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ConfigurationService } from '@draeger-academy/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'da-my-account',
    templateUrl: './my-account.component.html',
    styleUrls: ['./my-account.component.scss'],
    animations: [
        trigger('Enter', [state('newElement', style({})), transition(':enter', [style({}), animate('1s 1s')])]),
        trigger('openClose', [
            // ...
            state('open', style({
                position: 'absolute',
                height: '*',
                display: 'block',
                margin: '1.8rem 0'
            })),
            state('closed', style({
                position: 'absolute',
                height: '0px',
                display: 'none',
                margin: '1.8rem 0'
            })),
            transition('open => closed', [animate('0.1s')]),
            transition('closed => open', [animate('0.1s')])
        ])
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MyAccountComponent implements OnInit {
    public translationPrefix = 'myAccount';
    public headerLinks = {
        myCourses: '/my-courses',
        personalData: '/personal-data',
        startPage: '/landing'
    };
    public isPortal = false;
    private _$isOpen: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(private _configurationService: ConfigurationService, private _router: Router) {
        this._router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            this.toggleMenu(true);
        });
    }

    public get isOpen$(): Observable<boolean> {
        return this._$isOpen.asObservable();
    }

    ngOnInit() {
        this._configurationService.currentPortal$.subscribe((portalId) => {
            if (portalId) {
                this.isPortal = true;
                this.translationPrefix = 'account.linkLabel';
                this.headerLinks = {
                    myCourses: '/partner/' + portalId + '/account/courses-overview',
                    personalData: '/partner/' + portalId + '/account/personal-data',
                    startPage: '/partner/' + portalId + '/account'
                };
            }
        });
    }

    toggleMenu(forceHide?: boolean) {
        this._$isOpen.next(forceHide ? !forceHide : !this._$isOpen.getValue());
        if (this._$isOpen.getValue() === true) {
            if (window.addEventListener) {
                window.addEventListener('scroll', () => {
                    this._$isOpen.next(false);
                });
            }
        }
    }
}
